import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import Select from "../../../components/common/Select";

const AviationCategoryForm = ({
  aviationCategory,
  onSubmit,
  onCancel,
  errors,
  setErrors,
  dropDownOptions
}) => {
  const [formData, setFormData] = useState({
    id: aviationCategory?.id || null,
    flight_crew: aviationCategory?.flight_crew || "",
    cabin_inflight: aviationCategory?.cabin_inflight || "",
    flight_ops_dispatch: aviationCategory?.flight_ops_dispatch || "",
    air_traffic_services: aviationCategory?.air_traffic_services || "",
    medical: aviationCategory?.medical || "",
    management_regulatory: aviationCategory?.management_regulatory || "",
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (field, value) => {
    const updated = { ...formData, [field]: value };
    setFormData(updated);

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = {};

    if (
      !formData.flight_crew &&
      !formData.cabin_inflight &&
      !formData.flight_ops_dispatch &&
      !formData.air_traffic_services &&
      !formData.medical &&
      !formData.management_regulatory
    ) {
      newErrors.general =
        "Please select at least one aviation category (you may leave others blank)";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 my-3 sentry-mask">
      <Box>
        <Grid container spacing={2}>
          {/* Flight Crew */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Select
              error={!!errors.flight_crew}
              helperText={errors.flight_crew}
              label="Flight Crew"
              onChange={(value) => handleChange("flight_crew", value)}
              options={dropDownOptions.flightCrewChoices}
              value={formData.flight_crew}
            />
          </Grid>
          {/* Cabin / Inflight */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Select
              error={!!errors.cabin_inflight}
              helperText={errors.cabin_inflight}
              label="Cabin / Inflight"
              onChange={(value) => handleChange("cabin_inflight", value)}
              options={dropDownOptions.cabinInflightChoices}
              value={formData.cabin_inflight}
            />
          </Grid>

          {/* Flight Ops & Dispatch */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Select
              error={!!errors.flight_ops_dispatch}
              helperText={errors.flight_ops_dispatch}
              label="Flight Ops & Dispatch"
              onChange={(value) => handleChange("flight_ops_dispatch", value)}
              options={dropDownOptions.flightOpsDispatchChoices}
              value={formData.flight_ops_dispatch}
            />
          </Grid>

          {/* Air Traffic Services */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Select
              error={!!errors.air_traffic_services}
              helperText={errors.air_traffic_services}
              label="Air Traffic Services"
              onChange={(value) => handleChange("air_traffic_services", value)}
              options={dropDownOptions.airTrafficServiceChoices}
              value={formData.air_traffic_services}
            />
          </Grid>

          {/* Medical */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Select
              error={!!errors.medical}
              helperText={errors.medical}
              label="Medical"
              onChange={(value) => handleChange("medical", value)}
              options={dropDownOptions.medicalChoices}
              value={formData.medical}
            />
          </Grid>

          {/* Management / Regulatory */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <Select
              error={!!errors.management_regulatory}
              helperText={errors.management_regulatory}
              label="Management / Regulatory"
              onChange={(value) => handleChange("management_regulatory", value)}
              options={dropDownOptions.managementRegulatoryChoices}
              value={formData.management_regulatory}
            />
          </Grid>
        </Grid>

        {errors.general && (
          <Typography variant="caption" color="error">
            {errors.general}
          </Typography>
        )}
      </Box>
      <div className="flex justify-end space-x-2 mt-4">
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="submit" variant="contained" color="primary">
          Save
        </Button>
      </div>
    </form>
  );
};

export default AviationCategoryForm;
